import '../styles/Appointment.css';
import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import daniel from '../assets/Daniel.jpg';
import susan from '../assets/Susan.jpg';
import { FaCalendarAlt, FaClock, FaUserTie, FaVideo, FaPhone } from 'react-icons/fa';

export default function Appointment() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const consultants = [
        {
            name: "Dingani N. Daniels",
            role: "Senior Consultant",
            image: daniel,
            link: "https://appointmentwasa.youcanbook.me",
            available: true
        },
        {
            name: "Susan J. Daniels",
            role: "Senior Consultant",
            image: susan,
            link: "https://appointmentwasa1.youcanbook.me",
            available: true
        }
    ];

    return (
        <div className="appt-page">
            <Header />
            
            <main className="appt-main">
                <div className="appt-hero">
                    <div className="appt-badge">Book Now</div>
                    <h1>Schedule a Consultation</h1>
                    <p className="appt-subtitle">Meet with our experts to discuss your international plans</p>
                </div>

                <div className="consultants-section">
                    <div className="consultants-grid">
                        {consultants.map((consultant, index) => (
                            <div key={index} className="consultant-card">
                                <div className="consultant-image">
                                    <img src={consultant.image} alt={consultant.name} />
                                    {consultant.available && <span className="available-badge">Available</span>}
                                </div>
                                <h3>{consultant.name}</h3>
                                <p className="consultant-role">{consultant.role}</p>
                                <div className="consultant-info">
                                    <div className="info-row">
                                        <FaClock className="info-icon" />
                                        <span>15 - 30 min session</span>
                                    </div>
                                    <div className="info-row">
                                        <FaVideo className="info-icon" />
                                        <FaPhone className="info-icon" />
                                        <span>Online or Phone</span>
                                    </div>
                                </div>
                                <a 
                                    href={consultant.link} 
                                    target='_blank' 
                                    rel="noreferrer" 
                                    className="book-btn"
                                >
                                    <FaCalendarAlt /> Book Appointment
                                </a>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="appt-info-section">
                    <div className="info-box">
                        <h2>What to Expect</h2>
                        <ul>
                            <li>Personal assessment of your goals</li>
                            <li>Review of required documents</li>
                            <li>Timeline discussion</li>
                            <li>Next steps action plan</li>
                            <li>Q&A session</li>
                        </ul>
                    </div>
                    
                    <div className="info-box">
                        <h2>Preparation Tips</h2>
                        <ul>
                            <li>Have your CV/resume ready</li>
                            <li>Gather any existing documents</li>
                            <li>Note down specific questions</li>
                            <li>Check your internet connection</li>
                            <li>Find a quiet space</li>
                        </ul>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}